import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/system';

export const GroupHeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded?: boolean }>(({ theme, expanded }) => ({
  position: 'sticky',
  top: '-0.5rem',
  zIndex: 2,
  paddingTop: '0.5rem',
  paddingBottom: expanded ? '0.5rem' : 0,
  marginBottom: expanded ? '0.5rem' : 0,
  background: `var(--gt-group-row-bg, ${theme.palette.purple[50]})`,
  marginInline: '-0.5rem',
  paddingInline: '0.5rem',
}));

export const GroupHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '10px 15px 10px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  borderRadius: '14px',
  background: theme.palette.background.paper,
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  cursor: 'pointer',
  userSelect: 'none',
}));

export const ToggleIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '26px',
  height: '26px',
  flexShrink: 0,
  color: theme.palette.text.secondary,
  '& svg': {
    width: '26px',
    height: '26px',
  },
}));

export const SelectedCountChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'chipColor',
})<{ chipColor?: string }>(({ chipColor }) => ({
  display: 'inline-flex',
  minWidth: '31px',
  height: '20px',
  borderRadius: '26px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 6px',
  flexShrink: 0,
  boxSizing: 'border-box',
  marginLeft: '8px',
  backgroundColor: chipColor,
}));

export const labelSx: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '140%',
};

export const checkboxBoxSx: SxProps<Theme> = {
  minWidth: '2.25rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const chipTextSx: SxProps<Theme> = {
  color: (theme) => theme.palette.common.white,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '160%',
};
